import React, { lazy, Suspense, useMemo } from 'react';
import { useLayoutContext } from '../../../contexts/useLayoutContext';

const ReactApexChart = lazy(() => import('react-apexcharts'));

function Chart({ type, height, width = '100%', getOptions, className, props }) {
  const { skin, theme } = useLayoutContext();
  const options = useMemo(() => getOptions(props), [skin, theme, props]);

  return (
    <Suspense>
      <ReactApexChart
        type={type}
        height={height}
        width={width}
        options={options}
        series={props.series}
        className={className}
      />
    </Suspense>
  );
}

export default Chart;
